<form [formGroup]="form" class="input-grid-gaps grid-2col">
    <app-select-input
        id="headerId"
        [form]="form"
        label="service.patterns.header"
        [staticOptions]="store.headers$ | async"
        [valueKey]="'id'"
        showClear
        class="fr-2">
    </app-select-input>

    <app-select-input
        id="footerId"
        [form]="form"
        label="service.patterns.footer"
        [staticOptions]="store.footers$ | async"
        [valueKey]="'id'"
        showClear
        class="fr-2">
    </app-select-input>
    <app-check-input class="fr-2" [form]="form" id="archive" label="common.archive"></app-check-input>
</form>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="common.confirm" (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
